// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { fetchQuery } from 'react-relay';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';
import LoomPermissionQuery, {
	type LoomPermissionQuery as LoomPermissionQueryType,
} from './__generated__/LoomPermissionQuery.graphql.ts';

export const loomPermissionResource: RouteResource<{
	permitted: boolean;
} | null> = createResource<{ permitted: boolean } | null>({
	type: 'LOOM_USER_PERMISSION',
	getKey: (_routerContext, { tenantContext }) => {
		return tenantContext?.cloudId ?? 'current-cloud-id';
	},
	getData: async (_routerContext, { tenantContext }) => {
		try {
			const cloudId = tenantContext?.cloudId;
			if (!cloudId) {
				return null;
			}
			// fetchQuery is used to ensure that the return type is consistent with what is needed by loom's stores
			const data = await fetchQuery<LoomPermissionQueryType>(
				getRelayEnvironment(),
				LoomPermissionQuery,
				{
					resourceId: `ari:cloud:loom::site/${cloudId}`,
					permissionId: 'write', // TODO: Check permission structure of loom and product id in perms endpoint.
				},
				{ fetchPolicy: 'store-or-network' },
			).toPromise();

			if (!data) {
				return null;
			}
			return {
				permitted: !!data?.permitted,
			};
		} catch (error) {
			fireErrorAnalytics({
				error: error instanceof Error ? error : undefined,
				meta: {
					id: 'fetchLoomUserPermissions',
					packageName: 'jiraLoomResource',
					teamName: 'cross-flow-growth',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
			return null;
		}
	},
});

export function useLoomPermissionResource(): UseResourceHookResponse<{
	permitted: boolean;
} | null> {
	return useResource(loomPermissionResource);
}
